import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const RULES_PATCH_REQUEST = 'PATCH_RULES_REQUEST';
export const RULES_PATCH_FAILURE = 'PATCH_RULES_FAILURE';
export const RULES_PATCH_SUCCESS = 'PATCH_RULES_SUCCESS';

export const patchRule = (id, data) => {
    return function(dispatch) {
        dispatch({ type: RULES_PATCH_REQUEST });
        const params = [];
        params['id'] = id;
        return axios(apiRequestOptions(apiPath.RULES.PATCH, data, { params }))
            .then(transformHttpResponse)
            .then(response => dispatch({ type: RULES_PATCH_SUCCESS, rule: response.data }))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: RULES_PATCH_FAILURE, error });
                dispatch(errorRequestHandler(error));
            });
    }
};
